import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import { ReactComponent as DecreaseIndentIcon } from 'assets/icons/indentOut24.svg'
import { useIndentOutToggle } from 'common/Prose/Toolbar/hooks/useIndentOutToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import Styles from '../MobileToolbar.module.scss'

export const DecreaseIndentButton = observer((props: ButtonProps) => {
  const { disabled, handleClick } = useIndentOutToggle()

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Decrease indentation"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: false,
        [Styles.disabled]: disabled,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-decrease-indent-mark"
      {...props}
    >
      <DecreaseIndentIcon />
    </Button>
  )
})
